import { Backdrop, Typography, CircularProgress } from '@mui/material';

type TProps = {
  open: boolean;
};

export const Loading = ({ open }: TProps) => {
  return (
    <Backdrop
      sx={{
        color: 'common.white',
        zIndex: mainTheme => mainTheme.zIndex.modal + 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
      open={open}
    >
      <CircularProgress sx={{ color: '#11C473' }} size={56} />
      <Typography sx={{ fontWeight: '700', fontSize: '24px' }}>
        載入中...
      </Typography>
    </Backdrop>
  );
};
